export const LOAD_DATA = 'LOAD_DATA';
export const LOAD_IMAGES = "LOAD_IMAGES"

// Action to load data
export const loadData = (data) => ({
  type: LOAD_DATA,
  payload: data,
});

export const loadImages = (images) => ({
    type: LOAD_IMAGES,
    payload: images,
});
